// material-ui
import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';

// project imports
import Navigation from './DrawerContent/Navigation';
import useConfig from 'hooks/useConfig';

// ==============================|| HORIZONTAL MENU LIST ||============================== //

export default function CustomAppBar() {
  const { container } = useConfig();

  return (
    <AppBar
      elevation={0}
      sx={(theme) => {
        const line = theme.palette.mode === 'light' ? '#E0E0E0' : theme.palette.divider;
        return {
          top: 60,
          bgcolor: theme.palette.mode === 'light' ? '#F5F5F5' : theme.palette.grey[100],
          width: '100%',
          height: 62,
          justifyContent: 'center',
          borderTop: `1px solid ${line}`,
          borderBottom: `1px solid ${line}`,
          boxShadow: 'none',
          borderRadius: 0,
          zIndex: 1098,
          color: 'grey.500'
        };
      }}
    >
      <Container maxWidth={container ? 'xl' : false}>
        <Stack direction="row" sx={{ alignItems: 'center' }}>
          <Navigation />
        </Stack>
      </Container>
    </AppBar>
  );
}
